import { Helmet } from "react-helmet-async";
import ConquestMode from "src/sections/overview/dashboards/views/non-branded/conquest-mode/conquest-mode";

export default function CompetitorsConquestMode() {
    return (
        <>
            <Helmet>
                <title>Conquest Mode</title>
            </Helmet>

            <ConquestMode />
        </>
    );
}
